import React, { useState } from 'react';
import { toast } from 'react-toastify';
import css from '../AboutPage.module.css';

const ContactusForm = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    phone: '',
    email: '',
    message: '',
  });

  const handleOnChange = e => {
    setFormData({...formData, [e.target.name]: e.target.value});
  }
  const handleSubmit = e =>{
    e.preventDefault();

    fetch('https://hooks.zapier.com/hooks/catch/11291651/bsrun9b/', {
      method: 'POST',
      body: JSON.stringify({
        emailto: 'info@sommly.com',
        emailFrom: formData.email,
        subject: 'Sommly Contact Form',
        body: `
          <div style="width: 100%; min-height:500px; text-align:center;">
            <div style="margin: 50px 0 30px;">
              <img width="100" height="100" src="https://sommly-image-bucket.s3.us-east-2.amazonaws.com/sommly.png" alt="">
            </div>
            <div>
              <h4>Hello!</h4>
              <h5>You have received a contact form email from ${formData.email} with below information:</h5>
              <ul>
                <li>First Name: ${formData.firstName}</li>
                <li>Last Name: ${formData.lastName}</li>
                <li>Phone: ${formData.phone}</li>
                <li>Email: ${formData.email}</li>
                <li>Message: ${formData.message}</li>
              </ul>
            </div>
            <div style="margin: 20px 0 50px;">
              <p>Contect us: <span style="color: blue; text-decoration: underline">support@sommly.com</span></p>
            </div>
          </div>
        `
      })
    })
    .then( res => res.json())
    .then(data => {
      if(data){
        setFormData({
          firstName: '',
          lastName: '',
          phone: '',
          email: '',
          message: '',
        })
        toast.success('Your message have been sent successfully');
      }
    })
    .catch(err => {
      console.log(err);
    })
  }

  return (
    <div className={css.contactusWrapper}>
      <div className={css.contactusHeader}>
        <h2>Contact Us</h2>
        <p>
          Got a question? We’d love to hear from you.<br />
          Send us a message and we’ll respond as soon as possible.
        </p>
      </div>
      <div>
        <form onSubmit={handleSubmit} className={css.contactusForm}>

          <div className={css.contactInputs}>
            <div className={css.inputWrapper}>
              <label htmlFor="firstName">First Name</label>
              <input
                type="text"
                id='firstName'
                name='firstName'
                value={formData.firstName}
                onChange={handleOnChange}
              />
            </div>
            <div className={css.inputWrapper}>
              <label htmlFor="lastName">Last Name</label>
              <input
                type="text"
                id='lastName'
                name='lastName'
                value={formData.lastName}
                onChange={handleOnChange}
              />
            </div>
            <div className={css.inputWrapper}>
              <label htmlFor="phone">Phone</label>
              <input
                type="text"
                id='phone'
                name='phone'
                value={formData.phone}
                onChange={handleOnChange}
              />
            </div>
            <div className={css.inputWrapper}>
              <label htmlFor="email">Email</label>
              <input
                type="email"
                id='email'
                name='email'
                value={formData.email}
                onChange={handleOnChange}
              />
            </div>
          </div>

          <div className={css.inputWrapper} style={{marginTop: "20px"}}>
            <label htmlFor="message">Message</label>
            <textarea
              id='message'
              name='message'
              value={formData.message}
              onChange={handleOnChange}
              cols="10"
              rows="3"
            ></textarea>
          </div>

          <div className={css.btnsWrapper}>
            <button className={css.submitBtn} type="submit">Send</button>
          </div>

        </form>
      </div>
    </div>
  )
}

export default ContactusForm;
